import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import * as Styled from '../../styles';

const ResultBoxPending = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);

  return (
    <Styled.Box direction="column" align="center" gap="dimension_16">
      <FlexContainer direction="column" align="center" justify="center" gap="dimension_08">
        <img src={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/time_s.png`} alt="heart" />
        <Text align="center" type="fds_text_bold_XL" color="dark_500">
          {t('PreviousYears.result.pending')}
        </Text>
      </FlexContainer>
      <Text type="paragraphs" color="dark" size="S_M_M" align="center">
        {t('PreviousYears.result.pending.description')}
      </Text>
    </Styled.Box>
  );
};

export default ResultBoxPending;
